export default __webpack_public_path__ + "static/media/tr.9becdbdf.svg";